export default __webpack_public_path__ + "static/media/poi_ambulance.9cf10c23.svg";